export default __webpack_public_path__ + "static/media/Gabon.9fc6435f.png";